import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject, debounceTime, fromEvent, takeUntil } from "rxjs";
import { Menu } from "./../../models/menu.model";
import { USER_ROLE } from "../../models/user.model";


@Injectable({
  providedIn: "root",
})

export class MenuService {
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  private unsubscriber: Subject<any> = new Subject();

  public language: boolean = false;

  public collapseSidebar: boolean = window.innerWidth < 1200 ? true : false;

  constructor(private _router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(0), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 1200) {
          this.collapseSidebar = true;
        } else {
          this.collapseSidebar = false;
        }
      });
  }

  MENUITEMS: Menu[] = [
    {
      role:USER_ROLE.INSTRUCTOR,headTitle1: "Instructor",
    },
    // {
    //   role:USER_ROLE.INSTRUCTOR,level: 1,title: "Pages",icon: "sample-page",type: "sub",active: true,
    //   children: [
    //     { path: "/pages/sample-page-1", title: "Sample Page 1", type: "link", bookmark: true },
    //     { path: "/pages/sample-page-2", title: "Sample Page 2", type: "link" },
    //   ],
    // },
    { 
      role:USER_ROLE.USER,
      level: 1, path: "/user/profile", title: "Profile", icon: "user", type: "link" 
    },
    { 
      role:USER_ROLE.USER,
      level: 1, path: "/user/courses", title: "My courses", icon: "blog", type: "link" 
    },
    { 
      role:USER_ROLE.COMPANY,
      level: 1, path: "/company/inbox", title: "home", icon: "home", type: "link" 
    },
    { 
      role:USER_ROLE.COMPANY,
      level: 1, path: "/company/courses", title: "courses", icon: "blog", type: "link" 
    },
    { 
      role:USER_ROLE.COMPANY,
      level: 1, path: "/company/employee", title: "employee", icon: "user", type: "link" 
    },
    // {
    //   role:"sample",level: 1,title: "Profile",icon: "sample-page",type: "sub",active: true,
    //   children: [
    //     { path: "/pages/sample-page-1", title: "Sample Page 1", type: "link", bookmark: true },
    //     { path: "/pages/sample-page-2", title: "Sample Page 2", type: "link" },
    //   ],
    // },

    { 
      role:USER_ROLE.ADMIN,
      level: 1, path: "/admin/dashboard", title: "Dashboard", icon: "charts", type: "link" 
    },
    { 
      role:USER_ROLE.ADMIN,
      level: 1, path: "/admin/profile", title: "Profile", icon: "user", type: "link" 
    },
    { 
      role:USER_ROLE.ADMIN,
      level: 1, path: "/admin/courses", title: "Courses", icon: "learning", type: "link" 
    },
    { 
      role:USER_ROLE.ADMIN,
      level: 1, path: "/admin/users", title: "Users", icon: "user", type: "link" 
    },
    { 
      role:USER_ROLE.ADMIN,
      level: 1, path: "/admin/practical-exam", title: "Practical exam", icon: "knowledgebase", type: "link" 
    },
    { 
      role:USER_ROLE.ADMIN,
      level: 1, path: "/admin/category", title: "Category", icon: "bookmark", type: "link" 
    },
  ];
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  ngOnDestroy() {
    this.unsubscriber.complete();
  }
}
